import { Route, Routes, useLocation } from 'react-router-dom';

import { CabinetProvider as Cabinet } from './pages/cabinet/context';

import { useContext } from 'react';
import { GlobalContext } from './store';
import { AnimatePresence } from 'framer-motion';
import Done from './pages/done';

export default function AppRoutes() {
  const location = useLocation();
  const { state } = useContext(GlobalContext);

  return (
    <AnimatePresence exitBeforeEnter>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Cabinet />} />
        <Route path="/done" element={<Done />} />
      </Routes>
    </AnimatePresence>
  );
}
